import React from "react";

import { assetUrl } from "../core/assets";
import { Image } from "./image";

const FLEXSPACE_HOME_URL = "https://flexspace.ai";
const FLEXSPACE_LOGO_URL = assetUrl("logos/flexspace-logo-default.svg");

const fullBleedHeaderBarStyle: React.CSSProperties = {
  width: "100vw",
  boxSizing: "border-box",
};

export function FlexspaceLegalDocumentHeader() {
  return (
    <header
      className="bg-white border-bottom py-3 px-3 px-sm-4"
      style={fullBleedHeaderBarStyle}
    >
      <a
        href={FLEXSPACE_HOME_URL}
        rel="noopener noreferrer"
        className="d-inline-flex align-items-center"
      >
        <Image
          height={36}
          maxWidth={110}
          objectFit="contain"
          src={FLEXSPACE_LOGO_URL}
          alt="Flexspace"
        />
      </a>
    </header>
  );
}
